document.addEventListener("DOMContentLoaded", function () {
  const targetNode = document.body; // Observe the entire body or a specific container
  const config = { childList: true, subtree: true }; // Monitor child elements being added or removed

  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        const recomProductsLoaded = document.querySelector(
          '[data-section-id] form[data-type="add-to-cart-form"]'
        );
        if (recomProductsLoaded) {
          console.log("Recommended products added.");
          // Set a timeout before initializing product forms
          setTimeout(() => {
            initProductForms(); // Function to handle product forms logic
          }, 500); // Delay in milliseconds (adjust as needed)
          observer.disconnect(); // Stop observing after loading the script
        }
      }
    });
  });

  observer.observe(targetNode, config);
});

document.addEventListener("DOMContentLoaded", function () {
  const targetNode = document.body; // Observe the entire body or a specific container
  const config = { childList: true, subtree: true }; // Monitor child elements being added or removed

  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        // Check if the <product-recommendations> element is added
        const productRecommendations = document.querySelector(
          "product-recommendations.product-recommendations--loaded"
        );

        if (productRecommendations) {
          console.log("<product-recommendations> loaded.");

          // Call your initialization function with a timeout
          setTimeout(() => {
            initProductForms(); // Function to handle logic related to product forms
          }, 500); // Delay (adjust as needed)

          observer.disconnect(); // Stop observing after the element is detected
        }
      }
    });
  });

  observer.observe(targetNode, config);
});

function initProductForms() {
  
  // Select all product forms by the data-section-id or any dynamic identifier
  const productForms = document.querySelectorAll(
    '[data-section-id] form[data-type="add-to-cart-form"]'
  );

  // Loop through each form
  productForms.forEach((form) => {
    const sectionElement = form.closest("[data-section-id]");
    const sectionId = sectionElement?.getAttribute("data-section-id") || null;
    const productElement = form.closest("[data-product]");
    const productHandle = productElement?.getAttribute("data-product") || null;

    if (!productHandle) {
      console.warn(`Product handle is not available for section ${sectionId}.`);
      return;
    }

    const variantSelectors = form.querySelectorAll(".variant-select");

    // Add event listener to each variant select dropdown
    variantSelectors.forEach((select) => {
      select.addEventListener("change", function () {
        updateVariant(form, productHandle, sectionId); // Update variant when user changes the selection
      });
    });

    // Initialize variant update on page load
    updateVariant(form, productHandle, sectionId);
  });

  function updateVariant(form, productHandle, sectionId) {
    const selectedOptions = {};
    const variantIdInput = form.querySelector(".product-variant-id");
    const submitButton = form.querySelector(`#${sectionId}-submit`);

    if (!submitButton) {
      console.error(`Submit button for section ${sectionId} not found.`);
      return;
    }

    form.querySelectorAll(".variant-select").forEach((select) => {
      const optionName = select.getAttribute("data-option");
      const selectedValue = select.value;

      if (selectedValue) {
        selectedOptions[optionName] = selectedValue;
      }
    });

    fetch(`/products/${productHandle}.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((productData) => {
        const product = productData?.product;

        if (!product || !Array.isArray(product.variants)) {
          console.error("Product data or variants are unavailable.");
          return;
        }

        const matchingVariant = product.variants.find((variant) => {
          return Object.keys(selectedOptions).every((key, index) => {
            const optionValue = selectedOptions[key];
            return variant[`option${index + 1}`] === optionValue;
          });
        });

        if (matchingVariant) {
          if (variantIdInput) {
            variantIdInput.value = matchingVariant.id;
            variantIdInput.disabled = !(matchingVariant.inventory_quantity > 0);
          }
          submitButton.disabled = !(matchingVariant.inventory_quantity > 0);
        } else {
          if (variantIdInput) {
            variantIdInput.disabled = true;
          }
          submitButton.disabled = true;
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  }
}


